import axios from 'axios'

// 全局默认值
axios.defaults.timeout = 200000
// 创建一个 axios 实例
const instance = axios.create({
  baseURL: window.config.baseURL
})
export default {
  getVideo () {
    return instance.get('wap/data/course/courseIndex.json')
  }
}
